import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, Building2, TrendingUp, Image as ImageIcon, Phone } from 'lucide-react';
import { useLocale } from '../../context/LocaleContext';
import { useReducedMotionPreference } from './ReducedMotionProvider';

const navItems = [
  { path: '/', labelEn: 'Home', labelUr: 'صفحہ اول', icon: Home },
  { path: '/projects', labelEn: 'Projects', labelUr: 'منصوبے', icon: Building2 },
  { path: '/investment', labelEn: 'Investment', labelUr: 'سرمایہ کاری', icon: TrendingUp },
  { path: '/gallery', labelEn: 'Gallery', labelUr: 'گیلری', icon: ImageIcon },
  { path: '/contact', labelEn: 'Contact', labelUr: 'رابطہ', icon: Phone }
];

export const LiquidMobileNav = () => {
  const { pathname } = useLocation();
  const { isRtl } = useLocale();
  const { prefersReducedMotion } = useReducedMotionPreference();
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  // Hide mobile nav when typing in input/textarea/form fields or when viewport shrinks (keyboard open)
  useEffect(() => {
    const handleFocusIn = (e) => {
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) {
        setIsKeyboardOpen(true);
      }
    };
    const handleFocusOut = () => setIsKeyboardOpen(false);

    window.addEventListener('focusin', handleFocusIn);
    window.addEventListener('focusout', handleFocusOut);
    return () => {
      window.removeEventListener('focusin', handleFocusIn);
      window.removeEventListener('focusout', handleFocusOut);
    };
  }, []);

  // Only show on mobile screens (< 768px) and when keyboard is closed
  if (isKeyboardOpen || pathname.startsWith('/admin')) {
    return null;
  }

  const getIsActive = (path) => {
    if (path === '/') return pathname === '/';
    return pathname.startsWith(path);
  };

  return (
    <div className="md:hidden fixed bottom-3 left-3 right-3 z-40 font-sans pointer-events-none select-none">
      <nav className="pointer-events-auto bg-[#0B1118]/92 backdrop-blur-lg border border-[#B99A5B]/30 rounded-2xl p-1.5 shadow-[0_8px_32px_rgba(0,0,0,0.6)] flex items-center justify-around">
        {navItems.map((item) => {
          const isActive = getIsActive(item.path);
          const Icon = item.icon;
          const label = isRtl ? item.labelUr : item.labelEn;

          return (
            <Link
              key={item.path}
              to={item.path}
              className="relative flex flex-col items-center justify-center py-1.5 px-3 rounded-xl transition-colors text-center"
            >
              {isActive && (
                <motion.div
                  layoutId={prefersReducedMotion ? undefined : "mobileNavBubble"}
                  className="absolute inset-0 bg-gradient-to-r from-[#B99A5B] to-[#d4af37] rounded-xl shadow-md z-0"
                  transition={{
                    type: 'spring',
                    stiffness: 420,
                    damping: 32
                  }}
                />
              )}

              <Icon
                className={`w-5 h-5 relative z-10 transition-colors ${
                  isActive ? 'text-[#0B1118]' : 'text-[#F2EEE6]/70 hover:text-[#B99A5B]'
                }`}
              />
              <span
                className={`text-[9px] font-bold tracking-tight relative z-10 mt-0.5 ${
                  isActive ? 'text-[#0B1118]' : 'text-[#F2EEE6]/60'
                }`}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default LiquidMobileNav;
